var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"rules":_vm.validator.rules,"name":_vm.validator.name,"slim":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var failed = ref.failed;
return [_c('div',{staticClass:"PSlider"},[_c('vue-slide-bar',{directives:[{name:"e2e",rawName:"v-e2e",value:(("PSlider__" + _vm.name)),expression:"`PSlider__${name}`"}],class:{ '-hasError': failed },attrs:{"min":_vm.min,"max":_vm.max,"process-style":{
        backgroundColor: _vm.color,
      },"line-height":10,"tooltip-styles":{
        backgroundColor: _vm.color,
        borderColor: _vm.color,
      }},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }